import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import type { CustomRouteComponentProps } from 'react-router-dom';
import type { InjectedFormProps } from 'redux-form';
import { Field, FieldArray } from 'redux-form';

import type LocationRequestModel from 'ab-requestModels/location.requestModel';

import AddressField from 'af-fields/AddressField';
import Checkbox from 'af-fields/Checkbox';
import ColorPicker from 'af-fields/ColorPicker';
import Input from 'af-fields/Input';

import BackButton from 'af-components/BackButton';
import SubmitButton from 'af-components/SubmitButton';

import Department from './DepartmentList';
import styles from './styles.module.scss';

interface PathParams {
	id?: string;
}

interface OwnProps {
	onSubmit: (form: LocationRequestModel) => void;
}

type Props = OwnProps & CustomRouteComponentProps<PathParams> & InjectedFormProps<LocationRequestModel>;

const LocationForm: React.FC<Props> = (props) => {
	const { handleSubmit, form, submitting, invalid, touch, onSubmit } = props;

	const onColorFocus = React.useCallback(() => {
		touch('color');
	}, [touch]);

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<div className="form-box">
				<Row className="row--padded-top">
					<Col md={12}>
						<Field
							component={Input}
							label="Nickname"
							name="nickname"
							placeholder="Enter nickname"
							required={true}
							type="text"
						/>
					</Col>
					<Col md={5}>
						<Field
							component={ColorPicker}
							label="Color *"
							name="color"
							onFocus={onColorFocus}
						/>
					</Col>
					<Col className="m-b-xs" md={7}>
						<Field
							component={Checkbox}
							inline={true}
							label="Show in labor statistics"
							name="showInStatistics"
						/>
					</Col>
				</Row>
				<Row>
					<Col md={12}>
						<Field
							component={Input}
							label="Mobile Phone"
							name="phone"
							placeholder="Enter mobile phone"
							required={true}
							type="tel"
						/>
					</Col>
					<Col md={12}>
						<Field
							component={Input}
							label="Fax"
							name="fax"
							placeholder="Enter fax"
							type="tel"
						/>
					</Col>
				</Row>
				<AddressField
					aa1PropName="aa1"
					aa2PropName="aa2"
					aa3PropName="aa3"
					countryPropName="country"
					disableMap={true}
					formName={form}
					latitudePropName="latitude"
					localityPropName="locality"
					locationPropName="street"
					longitudePropName="longitude"
					postalCodePropName="postalCode"
					postalOfficeBoxPropName="postalOfficeBoxCode"
					routePropName="route"
					streetNumberPropName="streetNumber"
					suitePropName="suite"
				/>
				<Row>
					<Col md={24}>
						<FieldArray
							component={Department}
							label="Mobile Phone *"
							name="departments"
						/>
					</Col>
				</Row>
				<div className={styles.footerActions}>
					<BackButton />
					<SubmitButton
						disabled={invalid}
						reduxFormSubmitting={submitting}
					/>
				</div>
			</div>
		</form>
	);
};

export default React.memo(LocationForm);
